// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main List Container */
.list {
  flex: 1;
  height: 100vh;
  background: var(--color-bg-app);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* List Header */
.list-header {
  padding: var(--spacing-lg) var(--spacing-xl);
  border-bottom: 1px solid var(--color-border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-bg-surface);
}

.list-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  margin: 0;
  line-height: var(--line-height-tight);
}

.list-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

/* Buttons */
.btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-fast);
  border: none;
}

.btn__icon {
  width: 18px;
  height: 18px;
}

/* Invert plus icon on light theme for task creation */
[data-theme="light"] .btn--primary .btn__icon {
  filter: invert(1);
}

.btn--primary {
  background: var(--color-primary);
  color: var(--color-text-inverse);
}

.btn--primary:hover {
  background: var(--color-primary-hover);
}

.btn--secondary {
  background: transparent;
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-default);
}

.btn--secondary:hover {
  background: var(--color-bg-hover);
}

/* Invert sort icon in dark theme */
[data-theme="dark"] .btn--secondary .btn__icon {
  filter: invert(1);
}

/* Search Bar */
.list-search {
  position: relative;
  padding: var(--spacing-lg) var(--spacing-xl);
  background: var(--color-bg-surface);
  border-bottom: 1px solid var(--color-border-default);
}

.list-search__icon {
  position: absolute;
  left: calc(var(--spacing-xl) + var(--spacing-md));
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  opacity: 0.5;
  pointer-events: none;
}

/* Invert search icon in dark theme */
[data-theme="dark"] .list-search__icon {
  filter: invert(1);
}

.list-search__input {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md) var(--spacing-sm) 40px;
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font-size: var(--font-size-base);
}

.list-search__input::placeholder {
  color: var(--color-text-muted);
}

.list-search__input:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-color: var(--color-primary);
}

/* Task List Container */
.list-tasks {
  flex: 1;
  overflow-y: auto;
  background: var(--color-bg-surface);
}

/* Empty State */
.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl);
  gap: var(--spacing-lg);
  min-height: 300px;
}

.list-empty__text {
  font-size: var(--font-size-base);
  color: var(--color-text-muted);
}

/* ===========================
   TASK ROW
   =========================== */

.task-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--color-border-subtle);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  background: var(--color-bg-surface);
}

/* Drag Handle */
.task-drag-handle {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  opacity: 0;
  transition: opacity var(--transition-fast);
}

.task-row:hover .task-drag-handle {
  opacity: 0.4;
}

.task-drag-handle:hover {
  opacity: 0.7 !important;
}

.task-drag-handle:active {
  cursor: grabbing;
}

.task-drag-handle__icon {
  width: 100%;
  height: 100%;
  filter: brightness(0) saturate(100%) invert(50%);
}

.task-row:hover {
  background: var(--color-bg-hover);
}

.task-row--selected {
  background: var(--color-primary-light);
  border-left: 3px solid var(--color-primary);
  padding-left: calc(var(--spacing-lg) - 3px);
}

.task-row--completed {
  opacity: 0.6;
}

.task-row--completed .task-title {
  text-decoration: line-through;
  color: var(--color-completed-text);
}

/* Drag and Drop States */
.task-row--ghost {
  opacity: 0.4;
  background: var(--color-bg-hover);
}

.task-row--chosen {
  background: var(--color-bg-hover);
}

.task-row--chosen .task-drag-handle {
  cursor: grabbing;
  opacity: 1 !important;
}

.task-row--dragging {
  opacity: 0.8;
  transform: rotate(2deg);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Checkbox */
.task-checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid var(--color-border-default);
  border-radius: var(--radius-sm);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.task-checkbox:hover {
  border-color: var(--color-primary);
}

.task-checkbox--checked {
  background: var(--color-checkbox-checked);
  border-color: var(--color-checkbox-checked);
}

.task-checkbox__check {
  color: var(--color-text-inverse);
  font-size: 14px;
  line-height: 1;
}

/* Task Content */
.task-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.task-title-row {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.task-priority-dot {
  width: 6px;
  height: 6px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}

.task-priority-dot.priority-p1 {
  background: var(--color-priority-p1);
}

.task-priority-dot.priority-p2 {
  background: var(--color-priority-p2);
}

.task-priority-dot.priority-p3 {
  background: var(--color-priority-p3);
}

.task-priority-dot.priority-p4 {
  background: var(--color-priority-p4);
}

.task-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Task Metadata */
.task-metadata {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
}

/* Task Badges */
.task-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  border: 1px solid;
}

.task-badge__icon {
  width: 12px;
  height: 12px;
}

.task-badge--due {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #3b82f6;
}

.task-badge--today {
  background: var(--color-badge-due-today-bg);
  border-color: var(--color-badge-due-today-border);
  color: var(--color-badge-due-today-text);
}

.task-badge--overdue {
  background: var(--color-badge-due-today-bg);
  border-color: var(--color-badge-due-today-border);
  color: var(--color-badge-due-today-text);
}

.task-badge--recurrence {
  background: var(--color-badge-recurrence-bg);
  border-color: var(--color-badge-recurrence-border);
  color: var(--color-badge-recurrence-text);
}

.task-badge--checklist {
  background: #f0fdf4;
  border-color: #10b981;
  color: #10b981;
}

/* Task Tags */
.task-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-regular);
  border: 1px solid;
}

.task-tag--work {
  background: var(--color-tag-work-bg);
  border-color: var(--color-tag-work-border);
  color: var(--color-tag-work-text);
}

.task-tag--personal {
  background: var(--color-tag-personal-bg);
  border-color: var(--color-tag-personal-border);
  color: var(--color-tag-personal-text);
}

.task-tag--urgent {
  background: var(--color-tag-urgent-bg);
  border-color: var(--color-tag-urgent-border);
  color: var(--color-tag-urgent-text);
}

.task-tag--important {
  background: var(--color-tag-important-bg);
  border-color: var(--color-tag-important-border);
  color: var(--color-tag-important-text);
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/list-row.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,OAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,4CAA4C;EAC5C,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,mCAAmC;EACnC,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mEAAmE;EACnE,6CAA6C;EAC7C,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;gCAEgC;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,mDAAmD;EACnD,eAAe;EACf,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;EAC/C,sCAAsC;AACxC","sourcesContent":["/* Main List Container */\n.list {\n  flex: 1;\n  height: 100vh;\n  background: var(--color-bg-app);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* List Header */\n.list-header {\n  padding: var(--spacing-lg) var(--spacing-xl);\n  border-bottom: 1px solid var(--color-border-default);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--color-bg-surface);\n}\n\n.list-title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  margin: 0;\n  line-height: var(--line-height-tight);\n}\n\n.list-controls {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n/* Buttons */\n.btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border: none;\n}\n\n.btn__icon {\n  width: 18px;\n  height: 18px;\n}\n\n/* Invert plus icon on light theme for task creation */\n[data-theme=\"light\"] .btn--primary .btn__icon {\n  filter: invert(1);\n}\n\n.btn--primary {\n  background: var(--color-primary);\n  color: var(--color-text-inverse);\n}\n\n.btn--primary:hover {\n  background: var(--color-primary-hover);\n}\n\n.btn--secondary {\n  background: transparent;\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-default);\n}\n\n.btn--secondary:hover {\n  background: var(--color-bg-hover);\n}\n\n/* Invert sort icon in dark theme */\n[data-theme=\"dark\"] .btn--secondary .btn__icon {\n  filter: invert(1);\n}\n\n/* Search Bar */\n.list-search {\n  position: relative;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  background: var(--color-bg-surface);\n  border-bottom: 1px solid var(--color-border-default);\n}\n\n.list-search__icon {\n  position: absolute;\n  left: calc(var(--spacing-xl) + var(--spacing-md));\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n/* Invert search icon in dark theme */\n[data-theme=\"dark\"] .list-search__icon {\n  filter: invert(1);\n}\n\n.list-search__input {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md) var(--spacing-sm) 40px;\n  border: 1px solid var(--color-border-default);\n  border-radius: var(--radius-md);\n  background: var(--color-bg-surface);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-base);\n}\n\n.list-search__input::placeholder {\n  color: var(--color-text-muted);\n}\n\n.list-search__input:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-color: var(--color-primary);\n}\n\n/* Task List Container */\n.list-tasks {\n  flex: 1;\n  overflow-y: auto;\n  background: var(--color-bg-surface);\n}\n\n/* Empty State */\n.list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl);\n  gap: var(--spacing-lg);\n  min-height: 300px;\n}\n\n.list-empty__text {\n  font-size: var(--font-size-base);\n  color: var(--color-text-muted);\n}\n\n/* ===========================\n   TASK ROW\n   =========================== */\n\n.task-row {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-lg);\n  border-bottom: 1px solid var(--color-border-subtle);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  background: var(--color-bg-surface);\n}\n\n/* Drag Handle */\n.task-drag-handle {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: grab;\n  opacity: 0;\n  transition: opacity var(--transition-fast);\n}\n\n.task-row:hover .task-drag-handle {\n  opacity: 0.4;\n}\n\n.task-drag-handle:hover {\n  opacity: 0.7 !important;\n}\n\n.task-drag-handle:active {\n  cursor: grabbing;\n}\n\n.task-drag-handle__icon {\n  width: 100%;\n  height: 100%;\n  filter: brightness(0) saturate(100%) invert(50%);\n}\n\n.task-row:hover {\n  background: var(--color-bg-hover);\n}\n\n.task-row--selected {\n  background: var(--color-primary-light);\n  border-left: 3px solid var(--color-primary);\n  padding-left: calc(var(--spacing-lg) - 3px);\n}\n\n.task-row--completed {\n  opacity: 0.6;\n}\n\n.task-row--completed .task-title {\n  text-decoration: line-through;\n  color: var(--color-completed-text);\n}\n\n/* Drag and Drop States */\n.task-row--ghost {\n  opacity: 0.4;\n  background: var(--color-bg-hover);\n}\n\n.task-row--chosen {\n  background: var(--color-bg-hover);\n}\n\n.task-row--chosen .task-drag-handle {\n  cursor: grabbing;\n  opacity: 1 !important;\n}\n\n.task-row--dragging {\n  opacity: 0.8;\n  transform: rotate(2deg);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Checkbox */\n.task-checkbox {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--color-border-default);\n  border-radius: var(--radius-sm);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.task-checkbox:hover {\n  border-color: var(--color-primary);\n}\n\n.task-checkbox--checked {\n  background: var(--color-checkbox-checked);\n  border-color: var(--color-checkbox-checked);\n}\n\n.task-checkbox__check {\n  color: var(--color-text-inverse);\n  font-size: 14px;\n  line-height: 1;\n}\n\n/* Task Content */\n.task-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.task-title-row {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.task-priority-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: var(--radius-full);\n  flex-shrink: 0;\n}\n\n.task-priority-dot.priority-p1 {\n  background: var(--color-priority-p1);\n}\n\n.task-priority-dot.priority-p2 {\n  background: var(--color-priority-p2);\n}\n\n.task-priority-dot.priority-p3 {\n  background: var(--color-priority-p3);\n}\n\n.task-priority-dot.priority-p4 {\n  background: var(--color-priority-p4);\n}\n\n.task-title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--color-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Task Metadata */\n.task-metadata {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  flex-wrap: wrap;\n}\n\n/* Task Badges */\n.task-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-regular);\n  border: 1px solid;\n}\n\n.task-badge__icon {\n  width: 12px;\n  height: 12px;\n}\n\n.task-badge--due {\n  background: #eff6ff;\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.task-badge--today {\n  background: var(--color-badge-due-today-bg);\n  border-color: var(--color-badge-due-today-border);\n  color: var(--color-badge-due-today-text);\n}\n\n.task-badge--overdue {\n  background: var(--color-badge-due-today-bg);\n  border-color: var(--color-badge-due-today-border);\n  color: var(--color-badge-due-today-text);\n}\n\n.task-badge--recurrence {\n  background: var(--color-badge-recurrence-bg);\n  border-color: var(--color-badge-recurrence-border);\n  color: var(--color-badge-recurrence-text);\n}\n\n.task-badge--checklist {\n  background: #f0fdf4;\n  border-color: #10b981;\n  color: #10b981;\n}\n\n/* Task Tags */\n.task-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-regular);\n  border: 1px solid;\n}\n\n.task-tag--work {\n  background: var(--color-tag-work-bg);\n  border-color: var(--color-tag-work-border);\n  color: var(--color-tag-work-text);\n}\n\n.task-tag--personal {\n  background: var(--color-tag-personal-bg);\n  border-color: var(--color-tag-personal-border);\n  color: var(--color-tag-personal-text);\n}\n\n.task-tag--urgent {\n  background: var(--color-tag-urgent-bg);\n  border-color: var(--color-tag-urgent-border);\n  color: var(--color-tag-urgent-text);\n}\n\n.task-tag--important {\n  background: var(--color-tag-important-bg);\n  border-color: var(--color-tag-important-border);\n  color: var(--color-tag-important-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
